import getStickyOffsetY from './get-sticky-offset-y';

export default function getDetailsActiveScrollStatus(section: HTMLElement) {
  let fromTop = window.scrollY + getStickyOffsetY();
  return section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop
    ? true
    : false;
}
